export const LoadingSpinner = () => {
    const styles = {
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999999
      },
      spinner: {
        width: "60px",
        height: "60px",
        border: "8px solid #f0f4f433",
        borderTop: "8px solid #f0f4f4",
        borderRadius: "50%",
        animation: "spin 1s linear infinite"
      }
    };
    return (
      <div style={styles.overlay}>
        <div style={styles.spinner}></div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  };
  